import React, { Component } from 'react';
import { REST_API } from 'drapcode-constant';
import { snakeCaseToTitleCase } from '../../common/utils/api_utils';
export default class RefFieldsOptionSelect extends Component {
  state = {
    dataSourceField: '',
    refCollectionField: '',
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => {
      const { dataSourceField, refCollectionField } = this.state;
      const { name, handleSelectedMapping } = this.props;
      handleSelectedMapping(name, { dataSourceField, refCollectionField });
    });
  };

  getRefCollectionFieldOptions = () => {
    const { selectedField, collections } = this.props;
    const {
      refCollection: { collectionName },
    } = selectedField;

    const fieldRefCollection = collections.find((e) => e.collectionName === collectionName);
    return fieldRefCollection ? fieldRefCollection.fields : [];
  };

  render() {
    const { uniqueKeys, connectorType, value } = this.props;
    return (
      <>
        <div className="row my-2">
          <div className="col-md-4 col-lg-4 col-sm-4">
            {connectorType && connectorType === REST_API
              ? 'REST API'
              : snakeCaseToTitleCase(connectorType)}{' '}
            Field
          </div>
          <div className="col-md-8 col-lg-8 col-sm-8">
            <div className="row">
              <div className="col-md-5 col-lg-5 col-sm-5 text-center">
                <select
                  className="form-control form-control-sm custom-select-sm"
                  name={'dataSourceField'}
                  value={this.state.dataSourceField}
                  onChange={this.handleChange}
                >
                  <option value="">Select Key</option>
                  {uniqueKeys.map((field) => (
                    <option key={field} value={field}>
                      {field}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-1 col-lg-1 col-sm-1 text-center p-0 mt-1">or</div>
              <div className="col-md-6 col-lg-6 col-sm-6 text-center">
                <input
                  name={'dataSourceField'}
                  value={value ? value.dataSourceField : ''}
                  onChange={this.handleChange}
                  className="form-control form-control-sm"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row my-2">
          <div className="col-md-4 cl-lg-4 col-sm-4">
            <small>FindBy in internal Collection Field</small>
          </div>
          <div className="col-md-8 cl-lg-8 col-sm-8">
            <select
              className="form-control form-control-sm custom-select-sm"
              name={'refCollectionField'}
              value={value ? value.refCollectionField : ''}
              onChange={this.handleChange}
            >
              <option value="">Leave as Default reference/belongsTo field</option>
              {this.getRefCollectionFieldOptions().map((field) => (
                <option key={field.fieldName} value={field.fieldName}>
                  {field.fieldTitle.en}
                </option>
              ))}
            </select>
          </div>
        </div>
      </>
    );
  }
}
